import { render, staticRenderFns } from "./development.vue?vue&type=template&id=6b4041ae&scoped=true"
import script from "./development.vue?vue&type=script&lang=js"
export * from "./development.vue?vue&type=script&lang=js"
import style0 from "./development.vue?vue&type=style&index=0&id=6b4041ae&scoped=true&lang=scss"
import style1 from "./development.vue?vue&type=style&index=1&id=6b4041ae&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4041ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b4041ae')) {
      api.createRecord('6b4041ae', component.options)
    } else {
      api.reload('6b4041ae', component.options)
    }
    module.hot.accept("./development.vue?vue&type=template&id=6b4041ae&scoped=true", function () {
      api.rerender('6b4041ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/development.vue"
export default component.exports